<ion-header>
  <ion-toolbar mode="ios">
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-title class="ion-text-center">{{ "Select Drop Location" }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid no-padding>
    <ion-row>
      <ion-col
        class="ion-no-padding"
        size="12"
        *ngIf="locations?.length > 0; else noItems"
      >
        <ion-radio-group name="locationsGroup" [(ngModel)]="selectLocationId">
          <rcyl-location-item
            *ngFor="let location of locations"
            (locationChanged)="onLocationChange($event)"
            [selectedLocationId]="selectLocationId"
            [locationItem]="location"
          >
          </rcyl-location-item>
        </ion-radio-group>
      </ion-col>
      <ng-template #noItems>
        <div
          style="
            height: 60vh;
            display: flex;
            width: 100%;
            flex-direction: column;
          "
          class="ion-align-items-center ion-justify-content-center"
        >
          <div class="ion-text-center" *ngIf="locations === null">
            <ion-spinner></ion-spinner><br />
            <div font-medium>Fetching locations...</div>
          </div>
          <div class="ion-text-center" *ngIf="locations?.length === 0">
            <ion-title font-medium>No Locations</ion-title>
            <ion-text
              >There are no location. Please contact your admin.</ion-text
            >
          </div>
        </div>
      </ng-template>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer class="no-box-shadow" *ngIf="changedLocationId > 0">
  <ion-col size="12">
    <ion-button
      centered=""
      (click)="submit()"
      recykal-button
      size="large"
      expand="block"
      color="primary"
    >
      Proceed
    </ion-button>
  </ion-col>
</ion-footer>
